export default __webpack_public_path__ + "static/media/eventDashboard_equipment.eeb85791.svg";